module.exports = __webpack_public_path__ + "static/img/7.75b0c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/list/7.png
// module id = XIHF
// module chunks = 1